/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'archiveCustomerRunnerTicketAddonsBySystemGameId',
    message: messages.SUCCESS_ARCHIVE_CUSTOMER_RUNNER_TICKET_ADDONS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-addons/:systemGameId/archive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.archiveCustomerRunnerTicketAddonsBySystemGameId,
  },
  {
    action: 'createCustomerRunnerTicketAddonBySystemGameId',
    message: messages.SUCCESS_CREATE_CUSTOMER_RUNNER_TICKET_ADDON_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-addon/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.createCustomerRunnerTicketAddonBySystemGameId,
  },
  {
    action: 'copyCustomerRunnerTicketAddonsBySystemGameId',
    message: messages.SUCCESS_COPY_CUSTOMER_RUNNER_TICKET_ADDONS_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-addons/:systemGameId/copy',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.COPY_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.copyCustomerRunnerTicketAddonsBySystemGameId,
  },
  {
    action: 'deleteCustomerRunnerTicketAddonsBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_RUNNER_TICKET_ADDONS_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/runner-ticket-addons/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.deleteCustomerRunnerTicketAddonsBySystemGameId,
  },
  {
    action: 'getCustomerRunnerTicketAddonsBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_TICKET_ADDONS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-ticket-addons/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.getCustomerRunnerTicketAddonsBySystemGameId,
    scopes: [
      scopes.CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID,
      scopes.CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'unarchiveCustomerRunnerTicketAddonsBySystemGameId',
    message: messages.SUCCESS_UNARCHIVE_CUSTOMER_RUNNER_TICKET_ADDONS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-addons/:systemGameId/unarchive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UNARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.unarchiveCustomerRunnerTicketAddonsBySystemGameId,
  },
  {
    action: 'updateCustomerRunnerTicketAddonById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-addon/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_ADDON,
    requestSchema: requestSchemas.customerRunnerTicketAddons.updateCustomerRunnerTicketAddonById,
  },
];
